<!--
  ChangelogVersionBadge.vue
  
  Displays a version badge with optional "Latest" indicator.
  Used in ChangelogDialog to show version numbers with consistent styling.
  
  @example
  <ChangelogVersionBadge 
    version="1.2.3" 
    date="2025-11-15" 
    :is-latest="true" 
  />
-->
<template>
  <div class="flex items-center gap-3">
    <!-- Version Badge -->
    <div
      :class="[
        'flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-bold shadow-md',
        isLatest
          ? 'bg-gradient-to-r from-brand-500 to-brand-400 text-white'
          : 'bg-charcoal-700 text-charcoal-200',
      ]"
    >
      <span>v{{ version }}</span>
      <span v-if="isLatest" class="text-white/90"> • Latest </span>
    </div>

    <!-- Date -->
    <span class="text-xs font-medium text-charcoal-400">
      {{ date }}
    </span>
  </div>
</template>

<script setup lang="ts">
/**
 * Props for the ChangelogVersionBadge component
 */
interface Props {
  /** Semantic version string (e.g., "1.2.3") */
  version: string
  /** Release date in human-readable format */
  date: string
  /** Whether this is the latest/current version */
  isLatest?: boolean
}

withDefaults(defineProps<Props>(), {
  isLatest: false,
})
</script>
